enum CaseWorkbenchTaskStatuses {
    Open = "00000000-0000-0000-0000-000000000001",
    Completed = "00000000-0000-0000-0000-000000000002",
    Removed = "00000000-0000-0000-0000-000000000003"
}

export default CaseWorkbenchTaskStatuses;
